'use strict';

function PerformanceReviewInviteController(performanceReviewService, contactService, $location, $q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.upload = upload;
  vm.excludeEmployee = excludeEmployee;
  vm.postInvitations = postInvitations;

  function $onInit() {
    vm.imported = [];
    vm.postImport = { valid: [], invalid: [] };
    vm.visibility = { file: true, table: false };
    vm.unwind = performanceReviewService.urls.invite.base({ round: vm.round });
  }

  function upload(csv) {

    contactService.listContacts()
      .then(function(response) {
        if(response.data.length > 0) {
          var promises = response.data.map(function(contact) {
            return contactService.deleteContact(contact);
          });
          $q.all(promises).then(function(){
            return _upload(csv);
          });
        } else {
          return _upload(csv);
        }
      });


  }

  function _upload(csv) {
    return contactService.contactCsvImport(csv)
      .then(function(response) {
        vm.badFile = false;
        vm.badRows =  [];
        if (response.data.bad_rows.length > 0) {
          vm.badRows = response.data.bad_rows;
          return response;
        }
        else {
          var promises = response.data.contacts.map(function(contact) {
            return contactService.createContact(contact.contact, false);
          });
          $q.all(promises).then(function(){
            $location.url(vm.unwind);
          });
        }
        return response;
      })
      .catch(function() {
        vm.badFile = true;
        vm.badRows =  [];
      });
  }

  function excludeEmployee(index) {
    vm.imported.splice(index, 1);
  }

  function postInvitations() {

  }
}

module.exports = PerformanceReviewInviteController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-invite/performance-review-invite-import/performance-review-invite-import.controller.js
 ** module id = 257
 ** module chunks = 0
 **/